import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { ROOT_URL } from '../../api/ApiConfig';

export const getCoUserStats = createAsyncThunk(
  'coUserStats/getCoUserStats',
  async ({ group_id } = {}, { getState, rejectWithValue }) => {
    try {
      const { loginToken } = getState();
      const authToken = loginToken?.response?.token;
      const business_id = loginToken?.response?.user?.business_id;

      const params = {};
      if (group_id) params.group_id = group_id;

      const response = await axios.get(
        `${ROOT_URL}/co-users/status-stats/${business_id}`,
        {
          headers: {
            'Authorization': `Bearer ${authToken}`
          },
          params,
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const initialState = {
  loading: false,
  error: null,
  stats: null,
  lastFetchedGroupId: null,
};

const getCoUserStatsSlice = createSlice({
  name: 'getCoUserStats',
  initialState,
  reducers: {
    resetCoUserStatsState: (state) => {
      state.loading = false;
      state.error = null;
      state.stats = null;
      state.lastFetchedGroupId = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(getCoUserStats.pending, (state, action) => {
        const groupId = action.meta?.arg?.group_id ?? null;
        const sameGroup =
          state.lastFetchedGroupId != null &&
          String(state.lastFetchedGroupId) === String(groupId);
        state.loading = !(state.stats != null && sameGroup);
        state.error = null;
      })
      .addCase(getCoUserStats.fulfilled, (state, action) => {
        state.loading = false;
        state.stats = action.payload.data;
        state.lastFetchedGroupId = action.meta?.arg?.group_id ?? null;
        state.error = null;
      })
      .addCase(getCoUserStats.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
        state.stats = null;
      });
  }
});

export const { resetCoUserStatsState } = getCoUserStatsSlice.actions;
export default getCoUserStatsSlice.reducer;
